import React from 'react';
import style from './_form.scss';
import {Textarea} from 'components/vitrade-forms/common';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {Conversations} from 'api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {SingleFileUploader} from 'components/uploader';
import {Demands} from 'api';
import {ShowIf} from 'components/utils';
import classname from 'classnames';

class CreateConversationForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      content: '',
      isSubmit: false,
      id: this.props.id,
      files: [],
      qtyFiles: [
        {id: 0},
        {id: 1},
        {id: 2}
      ]
    };

    this.props.validators['formConversation'] = [];
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUploadCompleted = this.onUploadCompleted.bind(this);
    this.removeFile = this.removeFile.bind(this);
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formConversation'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {content} = this.state;
      const data = {
        content
      };
      this.setState({isSubmit: true});

      let files = [...this.state.files];
      files = files.filter(item => item);
      Conversations.actions.send.request(null, {
        data: {
          message: this.state.content,
          files: files,
          ...this.props.data
        }
      }).then(response => {
        this.props.onConversationCreate(response.data);
      }).finally(() => {
        this.setState({isSubmit: false});
      });
    }
  }


  onUploadCompleted(i, file) {
    if (!file || isNaN(i)) {
      return;
    }
    let files = [...this.state.files];
    files[i] = file.name;
    this.setState({files});
  }

  removeFile(i, e) {
    if (!e || isNaN(i)) {
      return;
    }
    let files = [...this.state.files];
    delete files[i];
    this.setState({files});
  }

  render() {
    const {image, content, isSubmit, categories, qtyFiles} = this.state;
    return (
      <div className="row">
        <form method="POST" onSubmit={this.onSubmit} noValidate>
          <div className={classname('user-form-wrap wrap-demand-conversation-first form-demand-detail', {
            'type-advisory-form': this.props.type === 'TUVAN'
          })}>
            <div className="box-wrap box-padding-20">
              <div className="complaint-content-wrap">
                <p className="box-header">Nội dung</p>
                <p className="form-warning">
                  <i className="fa fa-exclamation-circle"></i>
                  Giới hạn trong 300 kí tự.
                </p>
              </div>
              <Textarea type="text" placeholder="Nội dung tin nhắn..."
                className="contact-form-group"
                inputClassName="complaint-content"
                required={true}
                rows={3}
                maxLength={300}
                name="content"
                value={content}
                onChange={this.onChange}
                bindValidator={this} channel="formConversation"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"/>
              <ShowIf condition={this.props.type === 'BAOGIA'}>
                <div className="box-files-demands-upload">
                  {qtyFiles.map((item, i) => (
                    <SingleFileUploader
                      key={i}
                      fnUpload={Demands.actions.upload.request}
                      onRemoveFile={this.removeFile.bind(this, i)}
                      onUploadCompleted={this.onUploadCompleted.bind(this, i)}
                      confirmRemove={true}
                      type="BUSINESS"
                    />
                  ))}
                </div>
              </ShowIf>
              <div className="btn-submit-demand">
                <LaddaButton className="update-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Phản hồi</LaddaButton>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

CreateConversationForm.defaultProps = {
  validators: {}
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

export default withRouter(connect(mapStateToProps)(CreateConversationForm));



// WEBPACK FOOTER //
// ./components/conversations/CreateConversationForm.jsx